module.exports = __webpack_public_path__ + "img/obsolete.647cf3cd.png";